import { z } from "zod";

export namespace PaymentSummary {
  export const schema = z.object({
    $self: z.string().optional(),
    bonus: z.number().optional(),
    commission: z.number().optional(),
    date: z.string(),
    id: z.string(),
    net: z.number().optional(),
    total: z.number().optional(),
    surcharge: z.number().optional(),
    referencedRefund: z.number().optional(), //positive
    unreferencedRefund: z.number().optional(), //negative
    refundsTotal: z.number().optional(), //negative
    chargebacksTotal: z.number().optional(),
    chargebackFeesTotal: z.number().optional(),
    deductionsTotal: z.number().optional(),
    // Franchise fee recorded for the day (cents). Recorded only for now: NOT
    // shown and NOT part of `net` until confirmed (see SHOW_FRANCHISE_FEE).
    franchiseFee: z.number().optional(),
  });

  // Adyen charges a fixed fee per chargeback (in cents).
  export const CHARGEBACK_FEE = 2800; // $28.00

  export type Type = z.infer<typeof schema>;
}

export type PaymentSummary = PaymentSummary.Type;

export namespace PaymentSummary {
  export const surcharge = (paymentSummary: PaymentSummary) => {
    if (paymentSummary.surcharge) {
      return paymentSummary.surcharge;
    }
    // if (!paymentSummary.bonus) {
    //   return 0;
    // }
    // if (!paymentSummary.commission) {
    //   return paymentSummary.bonus ?? 0;
    // }
    // return (paymentSummary.bonus ?? 0) + paymentSummary.commission;

    return 0;
  };

  export const refund = (paymentSummary: PaymentSummary) => {
    return paymentSummary.refundsTotal ?? 0;
    // return (
    //   (paymentSummary.referencedRefund ?? 0) +
    //   (paymentSummary.unreferencedRefund ?? 0)
    // );
  };

  // The chargeback principal (sum of chargeback amounts for the day).
  export const chargeback = (paymentSummary: PaymentSummary) => {
    return paymentSummary.chargebacksTotal ?? 0;
  };

  // The fixed per-chargeback fees for the day ($28 x number of chargebacks).
  export const chargebackFee = (paymentSummary: PaymentSummary) => {
    return paymentSummary.chargebackFeesTotal ?? 0;
  };

  // Total chargeback cost deducted from the payout: principal + fees.
  export const chargebackTotal = (paymentSummary: PaymentSummary) => {
    return chargeback(paymentSummary) + chargebackFee(paymentSummary);
  };

  export const deductions = (paymentSummary: PaymentSummary) => {
    return paymentSummary.deductionsTotal ?? 0;
  };

  // Not included in `net` yet — the franchise fee is recorded only for now.
  export const franchiseFee = (paymentSummary: PaymentSummary) => {
    return paymentSummary.franchiseFee ?? 0;
  };

  export const net = (paymentSummary: PaymentSummary) => {
    return (
      (paymentSummary.net ?? 0) -
      refund(paymentSummary) -
      chargebackTotal(paymentSummary) -
      deductions(paymentSummary)
    );
  };
}
